import {
  authorizedDeleteRequest,
  authorizedGetRequest,
  authorizedPutRequest,
  authorizedPostRequest,
} from '@/api/requests';

const ORG_BASE = 'organizations';

export const getOrganizations = authorizedGetRequest(ORG_BASE);

export const getOrganizationProfile = orgname =>
  authorizedGetRequest(`${ORG_BASE}/${orgname}`);

export const getOrganizationMembers = orgname =>
  authorizedGetRequest(`${ORG_BASE}/${orgname}/members`);

export const setOrganizationDetails = orgname =>
  authorizedPutRequest(`${ORG_BASE}/${orgname}`);

// export const setOrganizationMember = authorizedPutRequest(
//   `${ORG_BASE}/edit/admins`
// );
export const setOrganizationMember = (accessToken, accountId, orgId) =>
  authorizedPostRequest(`organizations/${accountId}/admins`, {
    orgId,
  })(accessToken, {
    id: orgId,
  });

export const setOrganizationMemberRole = (
  accessToken,
  accountId,
  orgId,
  role
) =>
  authorizedPutRequest(`organizations/${accountId}/admins`)(accessToken, {
    id: orgId,
    role: role,
  });

export const deleteOrganizationMember = (orgname, member) =>
  authorizedDeleteRequest(`${ORG_BASE}/${orgname}/admins/${member}`);

export const putOrganizationDetails = orgId =>
  authorizedPutRequest(`${ORG_BASE}/${orgId}`);

export default {
  getOrganizations,
  getOrganizationProfile,
  getOrganizationMembers,
  setOrganizationDetails,
  setOrganizationMember,
  deleteOrganizationMember,
  putOrganizationDetails,
  setOrganizationMemberRole,
};
